import "./Cell.css"

const Cell = ({index, winner, handleChange}) => {
    // console.log(document.querySelector(".child"))
    return (
        <div className="cell" onClick={!winner ? (e) => handleChange(e, index) : () => {}}>
            <div className="child"></div>
        </div>
    )
}

export default Cell